import ClientsList from './ClientsList';
import ClientsItem from './ClientsItem';

export {
  ClientsList,
  ClientsItem,
};



// WEBPACK FOOTER //
// ./src/components/Clients/index.js